const AUTOPLAY_LIKE_BUTTON = ".vjs-autoplay__like-button";

function updateAutoplayLikeButton(newPlayerEl) {
  const lessonId = newPlayerEl.getAttribute("data-lesson-id");
  const likedStatus = newPlayerEl.getAttribute("data-liked-status");

  if (!lessonId) return;

  const button = document.querySelector(
    AUTOPLAY_LIKE_BUTTON
  ) as HTMLButtonElement;

  if (!button) return;

  const form = button.closest("form");
  const container = button.closest<HTMLElement>(
    "[data-save-toggle-active-value]"
  );
  const labelSpan = button.querySelector("span");

  if (form) {
    form.action = `/lesson/${lessonId}/likes/toggle`;
  }

  if (likedStatus != null) {
    button.dataset.status = likedStatus;
    if (container) {
      container.dataset.saveToggleActiveValue = likedStatus;
    }
    if (labelSpan) {
      labelSpan.textContent = likedStatus === "true" ? "Saved" : "Save lesson";
    }
  }
}

export { updateAutoplayLikeButton };
